import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/landing/HeroSection';
import ProblemSection from '../components/landing/ProblemSection';
import SolutionSection from '../components/landing/SolutionSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import ROISection from '../components/landing/ROISection';
import SuccessSection from '../components/landing/SuccessSection';
import CTASection from '../components/landing/CTASection';
import FooterSection from '../components/landing/FooterSection';

const LandingPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        background: '#0f1a34',
        scrollBehavior: 'smooth',
      }}
    >
      {/* Hero Section */}
      <HeroSection />

      {/* Problem Section */}
      <ProblemSection />

      {/* Solution Section */}
      <SolutionSection />

      {/* Features Section */}
      <FeaturesSection />

      {/* ROI Section */}
      <ROISection />

      {/* Success Stories Section */}
      <SuccessSection />

      {/* CTA Section */}
      <CTASection />

      {/* Footer Section */}
      <FooterSection />
    </Box>
  );
};

export default LandingPage;
